import { useState } from "react";
import { platformService } from "../../../services/platform.service";

const api = new platformService();

/** Matches backend FileAttachmentInput - DriveItemId plus one of DriveId/DriveItemGroupId (files must be uploaded first). */
type FilesToAddItem = { FileName: string; MediaType: string; FileSize: number; DriveItemId: string; DriveItemGroupId?: string; DriveId?: string };

type UpdateCommentPayload = {
    Comment: { Body: string; IsPublic: boolean };
    FilesToAdd?: FilesToAddItem[];
    FilesToDelete?: number[];
};

const updateComment = async (commentId: number, data: UpdateCommentPayload) => {
    const editCommentRes = await api.updateComment(commentId, data);
    return editCommentRes.data;
};

const updateCommentAndNotify = async (commentId: number, data: UpdateCommentPayload) => {
    const editCommentRes = await api.updateCommentAndNotify(commentId, data);
    return editCommentRes.data;
};

export const useUpdateEditableTicketChatContent = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const updateChatContent = async (
        commentId: number,
        body: string,
        isPublic: boolean = true,
        filesToAdd?: FilesToAddItem[],
        filesToDelete?: number[],
        notify: boolean = false
    ) => {
        setLoading(true);
        setError(null);

        try {
            const payload: UpdateCommentPayload = {
                Comment: { Body: body, IsPublic: isPublic },
                FilesToAdd: filesToAdd ?? [],
                FilesToDelete: filesToDelete ?? [],
            };

            const response = notify
                ? await updateCommentAndNotify(commentId, payload)
                : await updateComment(commentId, payload);
            setLoading(false);
            return response;
        } catch (err) {
            setError(err);
            setLoading(false);
            throw err;
        }
    };

    return { updateChatContent, loading, error };
};